export default __webpack_public_path__ + "03ad5445a0b6641547ed39d4f6ac1340.jpg";